import { usePermissionListContext } from "./PermissionListContext.tsx";
import { AutoGrid } from "src/components/Grid/layout/AutoGrid";

const PermissionGrid = () => {
    const {
        mrt_columns,
        gridKey,
        gridConfiguration,
        appSearch,
        menuItems,
        permissions = [],
        isReady,
        isRefetching,
        totalItems,
        pagination,
    } = usePermissionListContext();

    const isLoading = !isReady || isRefetching;

    return (
        <AutoGrid
            gridKey={gridKey}
            columns={mrt_columns}
            data={permissions}
            isLoading={isLoading}
            totalItems={totalItems}
            searchParams={appSearch}
            menuItems={menuItems}
            enableRowActions={menuItems.length > 0}
            columnsConfig={gridConfiguration}
            pagination={pagination}
        />
    );
};
export default PermissionGrid;
